import Checkout from "./Checkout";
import { localiseUrl } from "src/common/utils/format-localised-url";
import { connect } from "react-redux";
import compose from "recompose/compose";
import lifecycle from "recompose/lifecycle";
import withProps from "recompose/withProps";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import withCountry from "../../hocs/withCountry";
import { getCart } from "../../../store/selectors/cart";
import { withModel } from "../../data-providers/model";
import { guestTokenLogin } from "../../../facades/eagle/cart";
import linkFactory from "../../../analytics/factory/link";

const enhance = compose(
  withModel,
  withCountry,
  connect((state, props) => {
    let paymentMethods = get(getCart(state), "paymentMethods.items");
    if (isEmpty(paymentMethods)) {
      paymentMethods = get(props, "model.eagleModel.paymentMethods", []);
    }
    return { paymentMethods };
  }),
  withProps(({ checkoutUrl, paypalUrl, country }) => ({
    checkoutUrl: localiseUrl(country, checkoutUrl),
    paypalUrl: paypalUrl && localiseUrl(country, paypalUrl),
    handleCheckout: linkFactory({
      category: "Cart",
      action: "Clicked Checkout Button",
      label: "Standard Checkout",
    }),
  })),
  lifecycle({
    componentDidMount() {
      guestTokenLogin();
    },
  })
);

export default enhance(Checkout);
